
import { PartyPopper } from 'lucide-react';

export const FormInfoBox = () => {
  return (
    <>
      <h1 className="text-2xl md:text-3xl font-bold text-center mb-2">Fledgio Rust Course</h1>
      <h2 className="text-xl md:text-2xl font-semibold text-center mb-6 text-primary flex items-center justify-center gap-4">
        <PartyPopper className="text-primary animate-bounce" size={32} />
        Launch Campaign Registration
        <PartyPopper className="text-primary animate-bounce" size={32} />
      </h2>
      
      <div className="bg-blue-50 border-l-4 border-primary p-4 mb-8 text-sm md:text-base">
        <p className="font-medium">To celebrate our launch, we're offering one free place per organisation on our 5-day Rust Core Programming Course (max seats 10 in total).</p>
        <p className="mt-2">That means one seat for each organisation – and it's first come, first served!</p>
        <p>Fight it out amongst your colleagues, and we look forward to giving the winner(s) the full Fledgio treatment!</p>
      </div>
    </>
  );
};
